import { Product } from "../types";

export const productsEN: Product = {
    "Orange": "green",
    "Watermelon": "green",
    "Avocado": "green",
    "Apricots": "green",
    "Pineapple": "green",
    "Apples": "green",
    "Alica": "green",
    "Pears": "green",
    "Eggplant": "green",
    "Grapes": "green",
    "Grapefruit": "green",
    "Kiwi": "green",
    "Gooseberries": "green",
    "Strawberry": "green",
    "Mango": "green",
    "Raspberries": "green",
    "Blueberries": "green",
    "Plums": "green",
    "Lemon": "green",
    "Mandarin": "green",
    "Olives": "green",
    "Peaches": "green",
    "Raisins": "green",
    "Figs (fresh)": "green",
    "Red currants": "green",
    "Black currants": "green",
    "Artichokes": "green",
    "Swede": "green",
    "Zucchini": "green",
    "Cabbage": "green",
    "Capers": "green",
    "Carrots": "green",
    "Cucumber": "green",
    "Garlic": "green",
    "Paprika": "green",
    "Potato starch": "green",
    "Potatoes": "yellow",
    "Sago": "green",
    "Tapioca": "green",
    "Corn": "yellow",
    "Corn starch": "green",
    "Butter": "green",
    "Canola oil": "green",
    "Sunflower seeds": "red",
    "Sunflower oil": "green",
    "Walnuts": "red",
    "Onion": "green",
    "Walnut oil": "green",
    "Margarine": "green",
    "Bacon": "green",
    "Sugar": "green",
    "Honey": "green",
    "Glucose-fructose syrup": "green",
    "Jam": "green",
    "Berry syrup": "green",
    "Cotton candy": "green",
    "Sorbet": "green",
    "Frozen juice": "green",
    "Apple juice": "green",
    "Coca Cola": "green",
    "Coca Cola zero": "red",
    "Pepsi": "red",
    "Milk": "yellow",
    "Yogurt": "yellow",
    "Pumpkin": "green",
    "Radish": "green",
    "Beets": "green",
    "Celery": "green",
    "Sweet cream": "yellow",
    "Cottage cheese": "red",
    "Cheese": "red",
    "Yolk": "yellow",
    "Egg white": "red",
    "Egg": "red",
    "Gelatin": "red",
    "Black peppers": "green",
    "Peppermint": "green",
    "Red beans": "yellow",
    "Green peas": "yellow",
    "Coconut milk": "green",
    "Turnip": "green",
    "Tofu": "red",
    "Split peas": "red",
    "Cornflakes": "yellow",
    "Chips": "yellow",
    "Brussels sprouts": "yellow",
    "Cauliflower": "yellow",
    "Broccoli": "yellow",
    "Cooked spinach": "yellow",
    "Spinach (fresh)": "green",
    "Ice cream": "red",
    "Pasta": "red",
    "Sour cream": "yellow",
    "Milk chocolate": "red",
    "Bread": "red",
    "Chicken": "red",
    "Pork": "red",
    "Sausage": "red",
    "Hot dogs": "red",
    "Lentil": "red",
    "Sardels": "red",
    "Fish fingers": "red",
    "Fishballs": "red",
    "Chocolate cheese": "red",
    "Curd cream": "red",
    "Wheat flour": "red",
    "Cookies" : "red",
    "Oat flakes": "red",
    "Cashews": "red",
    "Almonds": "red",
    "Coconut yogurt": "green",
    "Aspartame": "red",
    "Acesulfame potassium": "red",
    "Sorbitol": "green",
    "Stevia": "green",
    "Instant potato porridge": "yellow",
    "Shrimps": "red",
    "Beef": "red",
    "Veal": "red",
    "Smoked meat": "red",
    "Vegan jellies": "green",
    "Jelly candies with gelatin": "red",
    "Dried apricots": "yellow",
    "Buckwheat": "red",
    "Asparagus": "yellow",
};

export const topProductsEN: Product = {
    "Peaches": "green",
    "Corn starch": "green",
    "Walnut oil": "green",
    "Margarine": "green",
    "Sour cream": "yellow",
    "Yolk": "yellow",
    "Zucchini": "green",
    "Gelatin": "red",
    "Sunflower seeds": "red",
    "Tofu": "red",
    "Cornflakes": "yellow",
    "Chips": "yellow",
    "Brussels sprouts": "yellow",
    "Apples": "green",
    "Broccoli": "yellow",
    "Cooked spinach": "yellow",
    "Milk chocolate": "red",
    "Sardels": "red",
    "Raisins": "green",
    "Fish fingers": "red",
    "Chocolate cheese": "red",
    "Cashews": "red",
    "Coconut milk": "green",
    "Aspartame": "red",
    "Pears": "green",
    "Instant potato porridge": "yellow",
    "Veal": "red",
    "Dried apricots": "yellow",
    "Swede": "green",
    "Asparagus": "yellow",
};